import {  Component,  HostBinding,  Input,  OnInit,  OnChanges,  Output,  EventEmitter,  ViewChild,  TemplateRef} from '@angular/core';
import moment from 'moment';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { NavItem } from './nav-item';
import { NavService } from '../../../../../services/nav.service';
import { LoginapiService } from '../../../../../components/auth/Pages/services/loginapi.service';
import { CharityDataShareServiceService } from '../../../../../components/charity/charities/services/charity-data-share-service.service';
import { MatDialog,  MatDialogModule,  MatDialogRef,  MatDialogActions,  MatDialogClose,  MatDialogTitle,  MatDialogContent} from '@angular/material/dialog';
import {  animate,  state,  style,  transition,  trigger} from '@angular/animations';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { debounce } from 'rxjs';
import { CharitiesService } from '../../../../../components/charity/charities/services/charities.service';
import { LocalStorageService } from '../../../../../Shared/common/local-storage.service';
import { BasicInformationDataShareService } from '../../../../../components/charity/basic-information/basic-information-data-share.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { UsermanagementService } from '../../../../../services/apps/usermanagement/usermanagement.service';
import { RolesModel } from '../../../../../Data/Models/Users/roles-model';
import { navItems } from '../sidebar-data';
import { NotesDatashareService } from '../../../../../components/charity/notes/services/notes-datashare.service';
import { FinalAccountsapiService } from '../../../../../components/charity/final-accounts/final-accountsapi.service';



@Component({
  selector: 'app-nav-item',
  standalone: true,
  imports: [CommonModule,RouterModule,TranslateModule,TablerIconsModule,MaterialModule,MatDialogModule,NgxSpinnerModule],
  templateUrl: './nav-item.component.html',
  styleUrls: [],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({ transform: 'rotate(-90deg)' })),
      state('expanded', style({ transform: 'rotate(0deg)' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4,0.0,0.2,1)'))
    ])
  ]
})
export class AppNavItemComponent implements OnChanges {
  @Input() item: NavItem | any;
  expanded = false;

  Navigations: NavItem[];


  @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;

  @Input() depth: any;
  @Output() toggleMobileLink = new EventEmitter<void>();
  @Output() notify = new EventEmitter<boolean>();
  @ViewChild('accountsSwitch') accountsSwitch!: TemplateRef<any>;


  disabled = false;
  twoLines = false;
  centralUserID!: number;
    //Charities_Service: any;
    openapperiod: boolean;
    OpenPeriod: any;
    AccountPeriodGrid: any;
    AccPerData: any;
    formattedDate: string;

  isLoadingResults: boolean = false;
  CurrentfinancialPeriodsID: any;


  private intervalId: any;
    temp: string;
    urls: string | undefined;
    highlightRoutes: string[];
  isdirty: any = false;

  constructor(
    public navService: NavService,
    public router: Router,
    private loginService: LoginapiService,
    private sharedService: CharityDataShareServiceService,
    public acservice: CharitiesService,
    private Charities_Service: CharitiesService, private Notesdatashare: NotesDatashareService,
    private datashare: BasicInformationDataShareService, private _UsermanagementService: UsermanagementService,
    public dialog: MatDialog, private lsService: LocalStorageService, private dataShareService: CharityDataShareServiceService,
    private apiservice: FinalAccountsapiService,
    private spinner: NgxSpinnerService) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
    
    this.intervalId = setInterval(() => {
      if (localStorage['userID']) {
        this.GetUserAccess()
        clearInterval(this.intervalId);
      }
    }, 600);

  }


  UserRoleAccess: RolesModel;
  GetUserAccess() {
    this._UsermanagementService.GetUserRoleAccess(localStorage['userID']).subscribe(data => {
      if (data.entity.length) {
        this.UserRoleAccess = data.entity[0]
        this.Navigations = navItems
        this.Navigations[0].access = true // Dashboard
        this.Navigations[1].access = (this.UserRoleAccess.m1View); // Charities

        this.Navigations[2].access = (this.UserRoleAccess.m4Edit || this.UserRoleAccess.m4Delete || this.UserRoleAccess.m4View || this.UserRoleAccess.m4Create );//settings

        this.Navigations[3].access = (this.UserRoleAccess.m1View); // Charities

        this.Navigations[4].access = (this.UserRoleAccess.m2View); // Submission History

        this.Navigations[5].access = (this.UserRoleAccess.m3GenerateReport); // Reports

        this.Navigations[6].access = (this.UserRoleAccess.m4Edit || this.UserRoleAccess.m4Delete || this.UserRoleAccess.m4View || this.UserRoleAccess.m4Create);//settings
        this.sharedService.finalStatus$.subscribe((value: any) => {
          //this.apFinalised = value != '' && value == 'Completed'
        })
        this.datashare.currentAPSubmitDate = this.UserRoleAccess.currentAPSubmitDate
        this.datashare.currentAPSubmitStatus = this.UserRoleAccess.currentAPSubmitStatus
        //this.datashare.isCurrentAPfainalise = this.UserRoleAccess.isCurrentAPfainalise
      }
    });
  }
  GetFinalAccountStatus(PeriodId: any) {
    debugger;
    this.apiservice.GetFinalStatus(PeriodId).subscribe((data: any) => {
      debugger
      this.datashare.isCurrentAPfainalise = data.mesage != '' && data.mesage == 'Completed'
      this.dataShareService.setFinalStatus(data.mesage)
    })
  }

  //Mathod for switch accounts
  OpenPeriod1(PeriodId: any, Record?: any) {
    debugger
    //  var period = `${Record.current_AP_End_Date.split('T')[0]} To ${Record.current_AP_Start_Date.split('T')[0]}`
    this.CurrentfinancialPeriodsID = PeriodId
    if (localStorage.getItem('currentPeriod') == PeriodId) {
      this.dialog.closeAll()
      return
    }
    const formatShortDate = (dateStr: string): string => {
      const date = new Date(dateStr);
      return new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      }).format(date);
    };

    const period = `${formatShortDate(Record.current_AP_Start_Date)} To ${formatShortDate(Record.current_AP_End_Date)}*${Record.financial_Year}`;


    //localStorage.setItem('currentPeriod', PeriodId);

    localStorage.setItem('SwitchcurrentPeriod', PeriodId);
  //  if (this.router.url.includes(`/basicinformation`)) {
      localStorage.setItem('currentCharityID', Record.charityID);
      this.lsService.setCurrentAccountingPeriod(PeriodId);
      this.dataShareService.updateFY_Year(period.toString());
      this.dataShareService.updateAccountMethodType(Record.accounting_Method.toString());
    this.dataShareService.updateAccountReportType(Record.report_Type.toString());
      //this.dataShareService.updateAccountMethodType(Record.accounting_Method.toString());
      localStorage.setItem('financial_Year', period.toString());
      localStorage.setItem('accounting_Method', Record.accounting_Method.toString());
      localStorage.setItem('ReportType_Method', Record.report_Type.toString());
      localStorage.setItem('fund_Tracking', Record.fund_Tracking.toString());
      var charity_Registration_Number: any = localStorage.getItem('charity_Registration_Number') == null ? '' : localStorage.getItem('charity_Registration_Number')
      this.dataShareService.updateCharityRegistraionNumb(charity_Registration_Number);
   // }
    //alert('ok')
    this.router.navigate(['/basicinformation']);
    document.body.classList.add('SwitchcurrentPeriod')
    this.GetFinalAccountStatus(PeriodId);
    this.datashare.CreateFinancialSubForm();
    this.Getbasicinformation()
    this.dialog.closeAll();

  }
  Getbasicinformation() {
    debugger
    const period = localStorage.getItem('SwitchcurrentPeriod');
    const charityId = localStorage.getItem('currentCharityID');
    if (this.router.url.includes(`/basicinformation`)) {
      var Id = localStorage.getItem("SwitchcurrentPeriod")
      if (localStorage.getItem("currentPeriod") != localStorage.getItem("SwitchcurrentPeriod") && Id != null && Id != '') {
        localStorage.setItem("currentPeriod", Id != null && Id != '' ? Id : '')
        var Id2 :any= Id != null && Id != '' ? Id : ''       
        this.dataShareService.UpdateCurrentAP_ID(+Id2)
       // localStorage.setItem("SwitchcurrentPeriod", '')
      }
    }
    this.Charities_Service.Getbasicinfo(charityId, period).subscribe((data: any) => {
      debugger
      var start = moment(data[0].current_AP_Start_Date, 'YYYY-MM-DD HH:mm:ss').format("DD/MM/YYYY");
      var end = moment(data[0].current_AP_End_Date, 'YYYY-MM-DD HH:mm:ss').format("DD/MM/YYYY");
      this.datashare.diffDays = (moment(end, "DD/MM/YYYY").diff(moment(start, "DD/MM/YYYY"), "days")) + 1;
      this.datashare.Basicinfodata = data;
      localStorage.setItem('FY_Year', this.datashare.Basicinfodata[0].financial_Year);
      this.datashare.createdDate = moment(data[0].createdDate, 'YYYY-MM-DD HH:mm:ss').format("DD/MM/YYYY");
      this.datashare.modifiedDate = data[0].modifiedDate ? moment(data[0].modifiedDate, 'YYYY-MM-DD HH:mm:ss').format("DD/MM/YYYY") : '-';
      this.datashare.CharityFinancialSubForm.controls['fund_Tracking'].setValue(data[0].fund_Tracking);
      localStorage.setItem('fund_Tracking', data[0].fund_Tracking);
      localStorage.setItem('IsFirstAccountingPeriod', data[0].withPrevoiusPeriod == 1 ? 'true' : 'false');
      localStorage.setItem('account_Type', data[0].account_Type.toString());
      this.dataShareService.UpdateCurrentAP_ID(data[0].financialPeriodsID)
      this.GetUserAccess()


    })
  }

  //AccountingPeriodGrid(charityID: any) {
  //  debugger;
  //  this.AccountPeriodGrid = [];

  //  this.Charities_Service.GetAccountsGrid(charityID).subscribe({
  //    next: (Response: any) => {
  //      debugger;
  //      this.AccountPeriodGrid = Response;

  //      if (this.openapperiod && this.AccountPeriodGrid.length == 1) {
  //        this.OpenPeriod(this.AccountPeriodGrid[0].financialPeriodsID, this.AccountPeriodGrid[0]);
  //      } else if (this.openapperiod) {
  //        this.OpenPeriod(this.AccountPeriodGrid[0].financialPeriodsID, this.AccountPeriodGrid[0]);
  //      } else {
  //        this.openapperiod = false;
  //      }
  //    },
  //    error: (err:any) => {
  //      console.error('Error fetching accounting periods:', err);
  //      this.openapperiod = false;
  //    }
  //  });
  //}
  viewcharity(id: any) {
    debugger
    this.dialog.closeAll();
    localStorage.setItem("currentCharityID", id)
    if (this.router.url.includes(`/charity`)) {
      this.sharedService.triggerveiwCharityMethod.next();

    } else {
      this.router.navigate(['charity']);

    }
  }
  checkUrl(): boolean {
    const url = this.navService.currentUrl(); // e.g. '/basicinformation'

    const highlightRoutes = [
      'basicinformation', 'trialbalance', 'receiptsandpayments', 'statement-financial-activities',
      'assets-statements', 'financialactivities', 'balancesheet', 'Accountnotes', 'trusteeannualreport',
      'statementoftrustees', 'independentexaminerreport', 'audit-report', 'final-accounts', 'submissions',
      'document-uploads', 'charity/notes/note1', 'charity/notes/note2', 'charity/notes/note3', 'charity/notes/note4', 'charity/notes/note5', 'charity/notes/note6', 'charity/notes/note7', 'charity/notes/note8', 'charity/notes/note9', 'charity/notes/note10', 'charity/notes/note11', 'charity/notes/note12', 'charity/notes/note13', 'charity/notes/note14', 'charity/notes/note15', 'charity/notes/note16', 'charity/notes/note17', 'charity/notes/note18', 'charity/notes/note19', 'charity/notes/note20', 'charity/notes/note21', 'charity/notes/note22', 'charity/notes/note23', 'charity/notes/note24', 'charity/notes/note25', 'charity/notes/note26', 'charity/notes/note27', 'charity/notes/note28', 'charity/notes/note29', 'charity/notes/note30','charity/Accountnotes'
    ];

    if (url) {
      const cleanedUrl = url.startsWith('/') ? url.slice(1) : url; // remove leading '/'
      return highlightRoutes.includes(cleanedUrl);
    }

    return false;
  }


  ngOnChanges(): void {

    this.Notesdatashare.isdirty$.subscribe(value => {
      this.isdirty = value
    })
    const url = this.navService.currentUrl();
    this.urls = url
 
    if (this.item.route && url) {
      //this.expanded = url.indexOf(`/${this.item.route}`) === 0;
    
        this.expanded = url.startsWith(`/${this.item.route}`);
        this.ariaExpanded = this.expanded;
      
    }
    const highlightRoutes = ['basicinformation', 'trialbalance', 'receiptsandpayments','statement-financial-activities',
      'assets-statements', 'financialactivities', 'balancesheet', 'Accountnotes', 'trusteeannualreport', 'statementoftrustees', 'independentexaminerreport', 'audit-report', 'final-accounts', 'submissions', 'document-uploads', 'note1', 'note2', 'note3', 'note4', 'note5','note6', 'note7', 'note8', 'note9'];
    if (highlightRoutes.some(route => url?.includes(route))) {
      this.DynamicSidenav(this.item);
    }
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
     
        
        const redirectUrl = event.urlAfterRedirects;
        const currentUrl = event.url;
        this.temp = event.url;

        if (highlightRoutes.some(route => currentUrl.includes(route) && redirectUrl.includes(route))) {
          this.DynamicSidenav(this.item);
        } else if (currentUrl.includes('charity') && redirectUrl.includes('charity')) {
          this.CharitySelect(this.item);
        }
        else if (currentUrl.includes('settings') && redirectUrl.includes('settings')) {
          this.CharitySelect(this.item);
        }
        else {
          this.expanded = false;
        }
      }
    });
  }

  SpinerShow() {
    this.sharedService.isLoadingResults$.subscribe(data => { this.isLoadingResults = data })

  }
  DynamicSidenav(item: NavItem) {

    if (item.displayName == "Charities") {
      this.expanded = true;
      //if (item.children && item.children.length > 0) {
      //  var result = item.children.find(x => x.displayName == 'Notes to the Accounts')
      //  if (this.temp?.includes('note')) {
      //    if(result)
      //    result.bgcolor='primary'
      //  }
      //}
    }
   
    this.sharedService.FY_Year$.subscribe(value => {
      if (item.displayName == 'Charities') {
        if (localStorage.getItem('financial_Year')) {
          const navCapValue = item.children?.[1]?.displayName?.toString() ?? '';
          if (item.children && item.children.length > 0) {
            item = this.ChangeSideBar(item, value);
          }
        }
      }
    });
    this.sharedService.finalStatus$.subscribe(value => {
      if (item.displayName == 'Charities') {
        //debugger
        if (value != '' && value == 'Completed') {
          let array = item.children?.filter(x => x.displayName == 'Submissions')
          if (array?.length == 0) {
            item.children?.splice(11, 0, {
              displayName: 'Submissions',
              iconName: 'database-share',
              bgcolor: 'primary',
              route: '/submissions',
              access: true
            })
          }
        }
        else {
          item.children = item.children?.filter(x => x.displayName != 'Submissions')
        }
      }
    });

    this.sharedService.AccountMethodType$.subscribe((value: any) => {
      if (item.displayName == 'Charities') {
        //if (value == 'Receipts & Payments') {
        if (value == 'Cash (Receipts & Payments)') {
          item.children = item.children?.filter(x => x.displayName != 'Statement of Financial Activities (SoFA)' && x.displayName != 'Balance Sheet')
          let array = item.children?.filter(x => x.displayName == 'Receipts & Payments')
          if (array?.length == 0) {
            item.children?.splice(4, 0, {
              displayName: 'Receipts & Payments',
              iconName: 'book',
              bgcolor: 'primary',
              route: '/receiptsandpayments',
              access: true
            },
              {
                displayName: 'Statement of Assets & Liabilities',
                iconName: 'file',
                bgcolor: 'primary',
                route: '/assets-statements',
                access: true
              })
          }
        }
        else if (value == 'Accruals (FRS 102 SORP)') {
          item.children = item.children?.filter(x => x.displayName != 'Receipts & Payments' && x.displayName != 'Statement of Assets & Liabilities')
          let details = item.children?.filter(x => x.displayName == 'Statement of Financial Activities (SoFA)')
          if (details?.length == 0) {
            item.children?.splice(4, 0, {
              displayName: 'Statement of Financial Activities (SoFA)',
              iconName: 'coins',
              bgcolor: 'primary',
              route: '/financialactivities',
              access: true
            }, {
              displayName: 'Balance Sheet',
              iconName: 'scale',
              bgcolor: 'primary',
              route: '/balancesheet',
              access: true
            })
          }
        }
      }
    })

    //this.sharedService.ReportTypeMethod$.subscribe((value: any) => {
    //  if (item.displayName == 'Charities') {
    //    //alert('ok')
    //    debugger
    //    //if (value == 'Receipts & Payments') {
    //    if (value == 'Independent Examiner') {

    //      //    {
    //      //      displayName: 'Auditor’s Report',
    //      //        iconName: 'fingerprint',
    //      //          bgcolor: 'primary',
    //      //            route: '/audit-report',
    //      //},
    //      //alert('Independent Examiner condition triggered');
    //      debugger
    //      item.children = item.children?.filter(x => (x.displayName != "Auditor's Report" && x.displayName != "Independent Examiner's Report"))
    //      let array = item.children?.filter(x => x.displayName == `Independent Examiner's Report`)
    //      /*          var length = localStorage.getItem('accounting_Method') == 'Cash(Receipts & Payments)' ? 10 : 9*/
    //      const method = localStorage.getItem('accounting_Method');
    //      const length = (method === 'Cash(Receipts & Payments)' || method === 'Cash (Receipts & Payments)' || method == 'Cash (Receipts & Payments)' || method?.includes('Receipts')) ? 10 : 9;
    //      if (array?.length == 0) {
    //        item.children?.splice(length, 0, {
    //          displayName: `Independent Examiner's Report`,
    //          iconName: 'file-description',
    //          bgcolor: 'primary',
    //          route: '/independentexaminerreport',
    //        })
    //        //alert('Independent Examiner’s Report added');
    //      }
    //    }

    //    else if (value == 'Auditor') {
    //      item.children = item.children?.filter(x => (x.displayName != `Independent Examiner's Report` && x.displayName != `Auditor's Report`))
    //      let details = item.children?.filter(x => x.displayName == "Auditor's Report")
    //      const method = localStorage.getItem('accounting_Method');
    //      const length = (method === 'Cash(Receipts & Payments)' || method === 'Cash (Receipts & Payments)' || method == 'Cash (Receipts & Payments)' || method?.includes('Receipts')) ? 10 : 9;
    //      //alert(`Auditor's Report found: ${details?.length}`);
    //      if (details?.length == 0) {
    //        //var accounting_Method = localStorage.getItem('accounting_Method');
    //        //var length = localStorage.getItem('accounting_Method') == 'Cash (Receipts & Payments)'?11:9

    //        item.children?.splice(length, 0, {
    //          displayName: "Auditor's Report",
    //          iconName: 'fingerprint',
    //          bgcolor: 'primary',
    //          route: '/audit-report',
    //        })

    //      }
    //    }
    //  }
    //})
    this.sharedService.ReportTypeMethod$.subscribe((value: any) => {
      //debugger
      if (value == 'Independent Examiner') {
        value = "Independent Examiner's Report"
      }
      else {
        value ="Auditor's Report"
      }
      if (item.displayName === 'Charities') {
        //const waitForChildren = setInterval(() => {
          if (item.children && item.children.length > 0) {
            //clearInterval(waitForChildren);

            const method = localStorage.getItem('accounting_Method');
            const length = (method?.includes('Receipts')) ? 8 : 8;
           var condition1 = item.children.some(x =>
             x.displayName == value
            );
            if (condition1) {
              return
            }
            else {
              //item.children = item.children.filter(item => item.displayName !== value)

              item.children = item.children.filter(x =>
                x.displayName !== "Auditor's Report" &&
                x.displayName !== "Independent Examiner's Report"
              );

              if (value === "Auditor's Report") {
                const details = item.children.filter(x => x.displayName === "Auditor's Report");
                if (details.length === 0) {
                  item.children.splice(length, 0, {
                    displayName: "Auditor's Report",
                    iconName: 'fingerprint',
                    bgcolor: 'primary',
                    route: '/audit-report',
                    access: true
                  });
                }
              }

            if (value === "Independent Examiner's Report") {
                const array = item.children.filter(x => x.displayName === "Independent Examiner's Report");
                if (array.length === 0) {
                  item.children.splice(length, 0, {
                    displayName: "Independent Examiner's Report",
                    iconName: 'file-description',
                    bgcolor: 'primary',
                    route: '/independentexaminerreport',
                    access: true
                  });
                }
              }
            }
          }
     //  }, 100); // Check every 100ms
      }
    });

  }
  CharitySelect(item: NavItem) {
    if (item.displayName == "Charities") {
      this.expanded = false;
     
    }
    if (item.displayName == "settings") {
      this.expanded = false;

    }
  }
  navigatetocharity(): void {
    const currentUser = localStorage.getItem('userID');
    if (currentUser) {
      this.centralUserID = +currentUser;
    }

    this.loginService.GetCharityGrid(this.centralUserID).subscribe((data: any) => {
      if (data > 0) {
        this.router.navigate(['/charity']);
      } else {
        this.router.navigate(['/landingPage']);
      }
    });
  }

 
  ChangeSideBar(item: NavItem, value: any): NavItem {
    if (item.children && item.children.length > 0) {
      
      item.children[1].displayName = value.split('*')[0];
      item.children[0].navCap = value.split('*')[1];
    }
    return item;
  }

  modal(templateRef: TemplateRef<any>): void {
    this.dialog.open(templateRef, {
      width: '30%',
      maxWidth: '50%',
     // disableClose: true
    });
  }
  isactive(): boolean {
    return this.router.url.includes('note') 
  }
  isreport(): boolean {
    return this.router.url.includes('reports') || this.router.url.includes('charitylistreport')
  }
  issettings(): boolean {
    return this.router.url.includes('settings')
  }
  onItemSelected(item: NavItem): void {
    debugger

  
   // if (item.bgcolor == 'secondary' && item.displayName == 'Charities' && item.iconName == "heart-handshake") {
    if (item.bgcolor == 'secondary' && !this.isdirty) {// for Bug - 1823     //isDirty added for bug 4002
      localStorage.setItem("currentCharityID", '')
      localStorage.setItem("currentPeriod", '')
      this.dataShareService.updateCharityRegistraionNumb('')
    }

    if (item.iconName === 'calendar') {
      this.CurrentfinancialPeriodsID = localStorage.getItem('currentPeriod')
      this.acservice.GetAccountsGrid(localStorage.getItem("charityId")).subscribe((data:any) => {
        debugger
        this.AccPerData = data;
        this.AccPerData.forEach((item:any) => {
          item.current_AP_Start_Date = moment(item.current_AP_Start_Date).format("DD MMM YYYY");
          item.current_AP_End_Date = moment(item.current_AP_End_Date).format("DD MMM YYYY");
        })
        //this.formattedDate = moment(this.AccPerData[0].current_AP_Start_Date).format("DD MMM YYYY");
        this.modal(this.accountsSwitch);
      })
      //this.modal(this.accountsSwitch);
      return;
    }

    if (item.displayName === 'Charities') {
      this.router.navigate(['/charity']);
    }

    const currentUser = localStorage.getItem('userID');
    if (currentUser) {
      this.centralUserID = +currentUser;
    }



    this.loginService.GetCharityGrid(this.centralUserID).subscribe((data: any) => {
      debugger
      if (data > 0) {
        if (!item.children || !item.children.length) {
          this.router.navigate([item.route]);
        } else {
          this.expanded = !this.expanded;
        }
      } else {
        if (item.route !== '/settings') {
          this.router.navigate(['/landingpage']);
        } else {
          this.router.navigate([item.route]);
        }
      }
    });

    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });

    if (!this.expanded && window.innerWidth < 1024) {
      this.notify.emit();
    }
  }

  onSubItemSelected(item: NavItem): void {
    if (!item.children || !item.children.length) {
      if (this.expanded && window.innerWidth < 1024) {
        this.notify.emit();
      }
    }
  }
}
